import { produce } from 'immer'

import promotion from './promotion'

const INITIAL_STATE = promotion.initialState

const reducerCases = { ...promotion.reducerCases }

export default (state = INITIAL_STATE, action) =>
  produce(state, draft => {
    const reducer = Object.keys(reducerCases).filter(
      item => item === action.type
    )

    if (reducer?.length) {
      reducerCases[reducer]({ state, draft, action })
    }
  })
